// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "GifPlayer-module--bx--text-truncate--end--2H9Yn";
export var bxTextTruncateFront = "GifPlayer-module--bx--text-truncate--front--R4pNo";
export var container = "GifPlayer-module--container--10VQD";
export var controls = "GifPlayer-module--controls--2FSns";
export var dark = "GifPlayer-module--dark--2OcQg";
export var gifDisplayed = "GifPlayer-module--gif-displayed--EMR18";
export var gifHidden = "GifPlayer-module--gif-hidden--25Dlm";
export var gifInDialog = "GifPlayer-module--gif-in-dialog--1QEWm";
export var imgDisplayed = "GifPlayer-module--img-displayed--2P6fw";
export var imgHidden = "GifPlayer-module--img-hidden--2fPz6";